import React from 'react';
import { Button, Divider, message, Modal } from 'antd';
import { CloseXIcon, FacebookIcon, LinkedinIcon, LinkIcon, TelegramIcon, Twitter, WhatsappIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { isBrowser } from 'modules/global';

interface IProps {
  open: boolean;
  onClose: () => void;
  shareUrl: string;
  title?: string;
}

const ShareModal = ({ open, onClose, shareUrl, title }: IProps) => {
  const t = useTranslations();
  const [messageApi, contextHolder] = message.useMessage();

  const getBaseUrl = (): string => {
    if (isBrowser()) {
      return window.location.origin;
    }
    return 'https://akam.uz';
  };
  
  const profileUrl = `${getBaseUrl()}${shareUrl}`;

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(profileUrl)
      .then(() => {
        messageApi.success(t('link_copied'));
      })
      .catch(() => {
        messageApi.error(t('copy_failed'));
      });
  };

  const shareFunctions = {
    facebook: () => {
      const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(profileUrl)}`;

      window.open(url, '_blank', 'width=600,height=400');
    },
    telegram: () => {
      const url = `https://t.me/share/url?url=${encodeURIComponent(profileUrl)}`;

      window.open(url, '_blank', 'width=600,height=400');
    },
    linkedin: () => {
      const url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(profileUrl)}`;

      window.open(url, '_blank', 'width=600,height=400');
    },
    twitter: () => {
      const url = `https://x.com/intent/tweet?url=${encodeURIComponent(profileUrl)}`;

      window.open(url, '_blank', 'width=600,height=400');
    },
    whatsapp: () => {
      const url = `https://wa.me/?text=${encodeURIComponent(profileUrl)}`;

      window.open(url, '_blank', 'width=600,height=400');
    }
  };

  return (
    <>
      {contextHolder}
      <Modal
        footer={false}
        open={open}
        centered
        onCancel={onClose}
        width="470px"
        styles={{
          content: { padding: '16px', borderRadius: '12px' }
        }}
        title={<span className="text-lg">{title}</span>}
        closeIcon={
          <div className="flex items-center justify-center rounded-full bg-gray-800 p-1">
            <CloseXIcon size="12" />
          </div>
        }
      >
        <Divider className="!my-0" />

        <div className="mt-5 space-y-8">
          <div className="flex items-center gap-4">
            <div className="flex cursor-pointer flex-col items-center" onClick={() => shareFunctions.telegram()}>
              <div className="w-13 h-13 flex items-center justify-center rounded-full bg-blue-400 p-3 text-white">
                <TelegramIcon />
              </div>
              {/* eslint-disable-next-line i18next/no-literal-string */}
              <p className="mt-1 text-xs font-medium">Telegram</p>
            </div>
            <div className="flex cursor-pointer flex-col items-center" onClick={() => shareFunctions.facebook()}>
              <div className="w-13 h-13 flex items-center justify-center rounded-full bg-blue-600 p-3 text-white">
                <FacebookIcon />
              </div>
              {/* eslint-disable-next-line i18next/no-literal-string */}
              <p className="mt-1 text-xs font-medium">Facebook</p>
            </div>
            <div className="flex cursor-pointer flex-col items-center" onClick={() => shareFunctions.whatsapp()}>
              <div className="w-13 h-13 flex items-center justify-center rounded-full bg-green-600 p-3 text-white">
                <WhatsappIcon />
              </div>
              {/* eslint-disable-next-line i18next/no-literal-string */}
              <p className="mt-1 text-xs font-medium">Whats App</p>
            </div>
            <div className="flex cursor-pointer flex-col items-center" onClick={() => shareFunctions.twitter()}>
              <div className="w-13 h-13 flex items-center justify-center rounded-full bg-sky-600 p-3 text-white">
                <Twitter />
              </div>
              {/* eslint-disable-next-line i18next/no-literal-string */}
              <p className="mt-1 text-xs font-medium">Twitter (X)</p>
            </div>
            <div className="flex cursor-pointer flex-col items-center" onClick={() => shareFunctions.linkedin()}>
              <div className="w-13 h-13 flex items-center justify-center rounded-full bg-blue-600 p-3 text-white">
                <LinkedinIcon />
              </div>
              {/* eslint-disable-next-line i18next/no-literal-string */}
              <p className="mt-1 text-xs font-medium">LinkedIn</p>
            </div>
          </div>

          <div className="flex items-center justify-between rounded-md bg-gray-100 p-2">
            <div className="flex items-center gap-2 overflow-hidden font-medium text-gray-700">
              <LinkIcon />
              <p className="flex-1 truncate text-xs">{profileUrl}</p>
            </div>
            <div>
              <Button
                className="!border-transparent !bg-green-500 !py-4 !font-medium !text-white"
                onClick={copyToClipboard}
              >
                {t('nusxa_olish')}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ShareModal;
